// extracted by mini-css-extract-plugin
export default {"menu":"HeaderNavigation_menu__F42Zw","menuLink":"HeaderNavigation_menuLink__NBEvi"};